// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2EE-9","label":"Labeled_label__XWvzP","divider":"Labeled_divider__1ycIV"};